import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { invalidando } from './queryClient';
import { SkinProfile } from '../types/entities';
import { AnamnesisFeedbackRequest, AnamnesisStatusDTO, RoutineAdviceDTO } from '../types/dtos';

export const CHAVES_PERFIL_PELE = {
  dominio: ['perfil-pele'] as const,
  perfil: (userId: string) => ['perfil-pele', 'perfil', userId] as const,
  anamnese: (userId: string) => ['perfil-pele', 'anamnese', userId] as const,
};

const SkinProfileService = {
  // POST /api/v1/users/{userId}/profile
  // Salvar a anamnese muda o perfil e zera o "está na hora de refazer".
  createOrUpdateProfile: (userId: string, profileData: Partial<SkinProfile>): Promise<AxiosResponse<SkinProfile>> =>
    api.post(`/users/${userId}/profile`, profileData).then(invalidando(CHAVES_PERFIL_PELE.dominio)),

  // GET /api/v1/users/{userId}/profile
  getProfile: (userId: string): Promise<AxiosResponse<SkinProfile>> =>
    api.get(`/users/${userId}/profile`),

  // GET /api/v1/users/{userId}/profile/anamnesis-status
  getAnamnesisStatus: (userId: string): Promise<AxiosResponse<AnamnesisStatusDTO>> =>
    api.get(`/users/${userId}/profile/anamnesis-status`),

  // POST /api/v1/users/{userId}/profile/ai-routine-suggestion
  getAiRoutineSuggestion: (userId: string): Promise<AxiosResponse<string>> =>
    api.post(`/users/${userId}/profile/ai-routine-suggestion`),

  // POST /api/v1/users/{userId}/profile/recommend-ai-routine
  // Só recomenda: nada é salvo (por isso não invalida). O usuário edita no modal
  // e salva via RoutineService, que aí sim derruba o cache de rotinas.
  // Junto vem o professionalAlert, quando o relato da anamnese pede um especialista.
  recommendAiRoutine: (userId: string): Promise<AxiosResponse<RoutineAdviceDTO>> =>
    api.post(`/users/${userId}/profile/recommend-ai-routine`),

  // POST /api/v1/users/{userId}/profile/feedback
  // Anamnese de feedback dos 30 dias: grava o feedback (o que reinicia o ciclo, daí a
  // invalidação) e devolve a rotina ADAPTADA para o usuário revisar. Nenhuma rotina é
  // salva aqui — quem salva continua sendo o RoutineService, pelo modal de revisão.
  submitFeedback: (
    userId: string,
    feedback: AnamnesisFeedbackRequest
  ): Promise<AxiosResponse<RoutineAdviceDTO>> =>
    api.post(`/users/${userId}/profile/feedback`, feedback).then(invalidando(CHAVES_PERFIL_PELE.dominio)),
};

export default SkinProfileService;
